import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { showModal } from "../statusModal/statusModal";
import {
  createAdminAPI,
  deleteAdminAPI,
  fetchAdminsAPI,
  updateAdminAPI,
} from "./adminsAPI";

const initialState = {
  list: [],
  fetchStatus: "idle",
  addStatus: "idle",
  deleteStatus: "idle",
  error: null,
};

export const fetchAdmins = createAsyncThunk(
  "admins/fetchAdmins",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const data = await fetchAdminsAPI();
      dispatch(
        showModal({
          message: "تم جلب بيانات الموظفين بنجاح",
          status: "success",
        })
      );
      return data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء جلب البيانات", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch admins"
      );
    }
  }
);

export const deleteAdmin = createAsyncThunk(
  "admins/deleteAdmin",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const data = await deleteAdminAPI(id);
      dispatch(
        showModal({
          message: `تم حذف ${data.data.name} بنجاح`,
          status: "success",
        })
      );
      return data.data._id;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء حذف الموظف", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete admin"
      );
    }
  }
);

export const createAdmin = createAsyncThunk(
  "admin/createAdmin",
  async (adminData, { dispatch, rejectWithValue }) => {
    try {
      const data = await createAdminAPI(adminData);
      dispatch(
        showModal({
          message: `تم انشاء موظف جديد بنجاح`,
          status: "success",
        })
      );
      return data.data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء انشاء الموظف", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete admins"
      );
    }
  }
);

export const updateAdmin = createAsyncThunk(
  "admin/updateAdmin",
  async ({ adminId, adminData }, { dispatch, rejectWithValue }) => {
    try {
      const data = await updateAdminAPI(adminId, adminData);

      dispatch(
        showModal({
          message: `تم التعديل على الموظف بنجاح`,
          status: "success",
        })
      );
      return data.data;
    } catch (error) {
      dispatch(
        showModal({
          message: "حصل خطأ اثناء التحديث على الموظف",
          status: "error",
        })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete admins"
      );
    }
  }
);

const adminsSLice = createSlice({
  name: "admins",
  initialState,
  reducers: {
    handleAdminWebSocketUpdate: (state, action) => {
      if (action.payload.type === "deleteAdmin") {
        state.list = state.list.filter(({ _id }) => _id !== action.payload.id);
      }

      if (action.payload.type === "addAdmin") {
        state.list.push(action.payload.admin);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdmins.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(fetchAdmins.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.list = action.payload.data;
      })
      .addCase(fetchAdmins.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(deleteAdmin.pending, (state) => {
        state.deleteStatus = "loading";
        state.error = null;
      })
      .addCase(deleteAdmin.fulfilled, (state, action) => {
        state.deleteStatus = "succeeded";
        state.list = state.list.filter(({ _id }) => _id !== action.payload);
      })
      .addCase(deleteAdmin.rejected, (state, action) => {
        state.deleteStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(createAdmin.pending, (state) => {
        state.addStatus = "loading";
        state.error = null;
      })
      .addCase(createAdmin.fulfilled, (state, action) => {
        state.addStatus = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(createAdmin.rejected, (state, action) => {
        state.addStatus = "failed";
        state.error = action.payload.error;
      })
      .addCase(updateAdmin.pending, (state) => {
        state.addStatus = "loading";
        state.error = null;
      })
      .addCase(updateAdmin.fulfilled, (state, action) => {
        state.addStatus = "succeeded";
        state.list = state.list.map((admin) => {
          return admin._id === action.payload._id ? action.payload : admin;
        });
      })
      .addCase(updateAdmin.rejected, (state, action) => {
        state.addStatus = "failed";
        state.error = action.payload.error;
      });
  },
});

export const { handleAdminWebSocketUpdate } = adminsSLice.actions;

export default adminsSLice.reducer;
